import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { UpperFirstLetterPipe } from '../../pipes/upper-first-letter-pipe';

@Component({
  selector: 'app-select-field',
  imports: [UpperFirstLetterPipe],
  templateUrl: './select-field.html',
  styleUrl: './select-field.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[class.filled]': 'filled()' },
})
export class SelectField {
  readonly label: InputSignal<string> = input.required<string>();
  readonly filled: InputSignal<boolean> = input<boolean>(false);
  readonly required: InputSignal<boolean> = input<boolean>(true);
  /** Message affiche sous le select (ex. champ requis non renseigne). */
  readonly errorMessage: InputSignal<string | undefined> = input<string>();
}
